import moment from 'moment';
import { DeviationsDto } from '../../../../../Component/Model/Dto/EmploymentEquity/Deviations';
import { SortDirections } from '../../../../../Component/Model/Dto/ColumnSortOption';

export type BadgeTone = 'positive' | 'negative' | 'neutral';

export function priorityBadgeLabel(movement: DeviationsDto.RecruitmentPromotionMovementDto): string {
    return movement.priorityAtDateOfMovement;
}

export function priorityBadgeTone(movement: DeviationsDto.RecruitmentPromotionMovementDto): BadgeTone {
    if (movement.priorityAtDateOfMovement === 'N/A') return 'neutral';
    return movement.priorityAtDateOfMovement === 'P1' ? 'positive' : 'negative';
}

export function deviationBadgeTone(deviationRelativeToPlan: string): BadgeTone {
    if (deviationRelativeToPlan === 'Yes') return 'negative';
    if (deviationRelativeToPlan === 'No') return 'positive';
    return 'neutral';
}

export function formatMovementDate(movementDate: string): string {
    return moment(movementDate).format('DD MMM YYYY');
}

export function rankSortValue(priorityRank: string): number {
    if (!priorityRank) return Number.MAX_SAFE_INTEGER;
    if (priorityRank.startsWith('P')) {
        const rankNumber: number = parseInt(priorityRank.substring(1), 10);
        if (!isNaN(rankNumber)) return rankNumber;
    }
    return Number.MAX_SAFE_INTEGER - 1;
}

export function deviationSortValue(deviationRelativeToPlan: string): number {
    if (deviationRelativeToPlan === 'Yes') return 0;
    if (deviationRelativeToPlan === 'No') return 1;
    return 2;
}

export function sortMovements(
    rows: DeviationsDto.RecruitmentPromotionMovementDto[],
    columnName: string,
    direction: SortDirections,
): DeviationsDto.RecruitmentPromotionMovementDto[] {
    const factor: number = direction === SortDirections.ASC ? 1 : -1;

    const compare = (a: DeviationsDto.RecruitmentPromotionMovementDto, b: DeviationsDto.RecruitmentPromotionMovementDto): number => {
        switch (columnName) {
            case 'MovementTypeId':
                return a.movementTypeId - b.movementTypeId;
            case 'Race':
                return a.raceId - b.raceId;
            case 'Gender':
                return a.genderId - b.genderId;
            case 'EmployeeName':
                return `${a.lastName ?? ''} ${a.firstName ?? ''}`.localeCompare(`${b.lastName ?? ''} ${b.firstName ?? ''}`);
            case 'PriorityAtDateOfMovement':
                return rankSortValue(a.priorityAtDateOfMovement) - rankSortValue(b.priorityAtDateOfMovement);
            case 'DeviationRelativeToPlan':
                return deviationSortValue(a.deviationRelativeToPlan) - deviationSortValue(b.deviationRelativeToPlan);
            case 'MovementDate':
            default:
                return new Date(a.movementDate).getTime() - new Date(b.movementDate).getTime();
        }
    };

    return [...rows].sort((a, b) => factor * compare(a, b));
}
